<template>
  <div class="notification-center">
    <div class="tab-header">
      <button v-for="tab in tabs" :key="tab.key"
        :class="['tab-btn', { active: activeTab === tab.key }]"
        @click="switchTab(tab.key)">
        {{ tab.label }}
        <span v-if="tab.key === 'alerts' && totalAlertCount > 0" class="badge">{{ totalAlertCount }}</span>
      </button>
    </div>

    <!-- 알림 센터 -->
    <div v-if="activeTab === 'alerts'" class="tab-content">
      <div v-if="warnings.length > 0" class="section">
        <div class="section-header">
          <h3 class="section-title">경고 (분실 의심)</h3>
          <button v-if="selectedWarnings.length > 0" class="btn-batch" @click="acknowledgeSelectedWarnings" :disabled="batchProcessing">
            선택 확인 ({{ selectedWarnings.length }})
          </button>
        </div>
        <table class="alert-table">
          <thead><tr>
            <th style="width:40px"><input type="checkbox" :checked="isAllWarningsSelected" @change="toggleAllWarnings($event.target.checked)"></th>
            <th>장치명</th><th>MAC</th><th>상태</th><th>경과</th>
          </tr></thead>
          <tbody>
            <tr v-for="w in warnings" :key="w.tag_mac" class="row-warning">
              <td><input type="checkbox" :value="w.tag_mac" v-model="selectedWarnings"></td>
              <td class="td-name td-link" @click.stop="goToTagList(w.devicename)">{{ w.devicename }}</td>
              <td class="td-mac">{{ w.tag_mac }}</td>
              <td><span class="status-badge badge-warning">분실 의심</span></td>
              <td class="td-time">{{ getTimeAgo(w.created_at) }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="notifications.length > 0" class="section">
        <div class="section-header">
          <h3 class="section-title">활성 알림</h3>
          <button v-if="selectedNotifications.length > 0" class="btn-batch" @click="acknowledgeSelectedNotifications" :disabled="batchProcessing">
            선택 확인 ({{ selectedNotifications.length }})
          </button>
        </div>
        <table class="alert-table">
          <thead><tr>
            <th style="width:40px"><input type="checkbox" :checked="isAllNotificationsSelected" @change="toggleAllNotifications($event.target.checked)"></th>
            <th>장치명</th><th>MAC</th><th>상태</th><th>현재값</th><th>시간</th>
          </tr></thead>
          <tbody>
            <tr v-for="n in notifications" :key="n.tag_mac + '-' + n.send_time" :class="'row-' + statusType(n)">
              <td><input type="checkbox" :value="n.tag_mac" v-model="selectedNotifications"></td>
              <td class="td-name td-link" @click.stop="goToTagList(n.devicename)">{{ n.devicename }}</td>
              <td class="td-mac">{{ n.tag_mac }}</td>
              <td><span class="status-badge" :class="'badge-' + statusType(n)">{{ statusLabel(n.status) }}</span></td>
              <td class="td-value">{{ getCurrentValue(n) }}</td>
              <td class="td-time">{{ n.send_time_formatted }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="warnings.length === 0 && notifications.length === 0" class="empty-state">
        활성 알림이 없습니다
      </div>
    </div>

    <!-- 히스토리 -->
    <div v-if="activeTab === 'history'" class="tab-content">
      <div class="filter-bar">
        <select v-model="historyFilter.event_type">
          <option value="">전체 유형</option>
          <option value="warning_missing">분실 의심</option>
          <option value="high_temp">고온</option>
          <option value="low_temp">저온</option>
          <option value="low_battery">배터리 부족</option>
          <option value="moved">이동 감지</option>
          <option value="wake_up">활성화</option>
          <option value="sleep">비활성화</option>
        </select>
        <input type="date" v-model="historyFilter.start_date">
        <span class="filter-sep">~</span>
        <input type="date" v-model="historyFilter.end_date">
        <button class="btn-search" @click="fetchHistory(1)">검색</button>
        <button class="btn-reset" @click="resetHistoryFilter">초기화</button>
      </div>

      <div v-if="historyItems.length > 0">
        <div v-if="isAdmin" class="section-header" style="margin-bottom:8px">
          <span></span>
          <button v-if="selectedHistory.length > 0" class="btn-batch btn-batch-danger" @click="deleteSelectedHistory" :disabled="batchProcessing">
            선택 삭제 ({{ selectedHistory.length }})
          </button>
        </div>
        <table class="alert-table">
          <thead><tr>
            <th v-if="isAdmin" style="width:40px"><input type="checkbox" :checked="isAllHistorySelected" @change="toggleAllHistory($event.target.checked)"></th>
            <th>유형</th><th>장치명</th><th>MAC</th><th>내용</th><th>확인자</th><th>확인 시간</th><th v-if="isAdmin" style="width:36px"></th>
          </tr></thead>
          <tbody>
            <tr v-for="h in historyItems" :key="h.id">
              <td v-if="isAdmin"><input type="checkbox" :value="h.id" v-model="selectedHistory"></td>
              <td><span class="status-badge" :class="'badge-type-' + h.event_type">{{ eventTypeLabel(h.event_type) }}</span></td>
              <td class="td-name">{{ h.devicename || '-' }}</td>
              <td class="td-mac">{{ h.tag_mac }}</td>
              <td class="td-msg">{{ h.event_msg }}</td>
              <td>{{ h.acknowledged_by || '-' }}</td>
              <td class="td-time">{{ formatDate(h.acknowledged_at) }}</td>
              <td v-if="isAdmin"><button class="btn-x" @click="deleteHistory(h.id)">&times;</button></td>
            </tr>
          </tbody>
        </table>
        <div v-if="historyPagination.totalPages > 1" class="pagination">
          <button :disabled="historyPagination.page <= 1" @click="fetchHistory(historyPagination.page - 1)">&lt;</button>
          <span>{{ historyPagination.page }} / {{ historyPagination.totalPages }} ({{ historyPagination.total }}건)</span>
          <button :disabled="historyPagination.page >= historyPagination.totalPages" @click="fetchHistory(historyPagination.page + 1)">&gt;</button>
        </div>
      </div>
      <div v-else class="empty-state">히스토리가 없습니다</div>
    </div>

    <!-- 설정 -->
    <div v-if="activeTab === 'settings'" class="tab-content">
      <div v-if="settingsLoaded" class="settings-grid">
        <div class="settings-card">
          <h3 class="card-title">온도 임계값</h3>
          <div class="s-row"><label>고온 경고 (&deg;C)</label><input type="number" v-model.number="settings.high_temp_threshold" step="0.1"></div>
          <div class="s-row"><label>저온 경고 (&deg;C)</label><input type="number" v-model.number="settings.low_temp_threshold" step="0.1"></div>
        </div>
        <div class="settings-card">
          <h3 class="card-title">배터리 임계값 (V)</h3>
          <div class="s-row"><label>양호</label><input type="number" v-model.number="settings.battery_good_threshold" step="0.1"></div>
          <div class="s-row"><label>불량</label><input type="number" v-model.number="settings.battery_bad_threshold" step="0.1"></div>
        </div>
        <div class="settings-card">
          <h3 class="card-title">알림 ON/OFF</h3>
          <div class="s-row"><label>온도 알림</label><label class="switch"><input type="checkbox" v-model="settings.temp_alert_enabled"><span class="slider"></span></label></div>
          <div class="s-row"><label>분실 알림</label><label class="switch"><input type="checkbox" v-model="settings.lost_alert_enabled"><span class="slider"></span></label></div>
        </div>
        <div class="settings-card">
          <h3 class="card-title">체크 주기</h3>
          <div class="s-row"><label>알림 간격 (분)</label><input type="number" v-model.number="settings.notification_interval" min="1"></div>
          <div class="s-row"><label>분실 체크 (시간)</label><input type="number" v-model.number="settings.lost_check_hours" min="1"></div>
        </div>
        <div class="settings-actions">
          <button class="btn-save" @click="saveSettings" :disabled="savingSettings">
            {{ savingSettings ? '저장 중...' : '설정 저장' }}
          </button>
          <span v-if="settingsMsg" :class="['settings-msg', settingsMsgType]">{{ settingsMsg }}</span>
        </div>
      </div>
      <div v-else class="empty-state">설정을 불러오는 중...</div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      activeTab: 'alerts',
      tabs: [
        { key: 'alerts', label: '알림 센터' },
        { key: 'history', label: '히스토리' },
        { key: 'settings', label: '설정' }
      ],
      warnings: [],
      notifications: [],
      selectedWarnings: [],
      selectedNotifications: [],
      selectedHistory: [],
      batchProcessing: false,
      historyItems: [],
      historyPagination: { page: 1, totalPages: 1, total: 0 },
      historyFilter: { event_type: '', start_date: '', end_date: '' },
      settings: {},
      settingsLoaded: false,
      savingSettings: false,
      settingsMsg: '',
      settingsMsgType: 'success',
      autoRefreshInterval: null,
      isAdmin: localStorage.getItem('isadmin') === '1' || localStorage.getItem('isadmin') === 'true'
    };
  },

  computed: {
    totalAlertCount() {
      return this.warnings.length + this.notifications.length;
    },
    isAllWarningsSelected() {
      return this.warnings.length > 0 && this.selectedWarnings.length === this.warnings.length;
    },
    isAllNotificationsSelected() {
      return this.notifications.length > 0 && this.selectedNotifications.length === this.notifications.length;
    },
    isAllHistorySelected() {
      return this.historyItems.length > 0 && this.selectedHistory.length === this.historyItems.length;
    }
  },

  methods: {
    goToTagList(devicename) {
      if (devicename) {
        this.$router.push({ path: '/tagList', query: { filter: devicename } });
      }
    },

    getCurrentValue(n) {
      if (n.high_flag === 1 || n.low_flag === 1) {
        return n.tag_temperature != null
          ? `${Number(n.tag_temperature).toFixed(1)}°C`
          : '-';
      }
      if (n.vol_flag === 1) {
        return n.tag_vol != null
          ? `${Number(n.tag_vol).toFixed(2)}V`
          : '-';
      }
      return '-';
    },

    switchTab(key) {
      this.activeTab = key;
      if (key === 'history') this.fetchHistory(1);
      if (key === 'settings' && !this.settingsLoaded) this.fetchSettings();
    },

    // === 알림 센터 ===
    async fetchWarnings() {
      try {
        const company = localStorage.getItem('company');
        const response = await axios.get('/api/warningMapTagList', { params: { company } });
        this.warnings = response.data || [];
      } catch (error) {
        console.error('Failed to fetch warnings:', error);
      }
    },

    async fetchNotifications() {
      try {
        const company = localStorage.getItem('company');
        const response = await axios.get('/api/notificationCenter', { params: { company } });
        this.notifications = (response.data || []).map(item => ({
          ...item,
          status: this.determineStatus(item),
          send_time_formatted: new Date(item.send_time).toLocaleString('ko-KR', {
            month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit'
          })
        }));
      } catch (error) {
        console.error('Error fetching notifications:', error);
      }
    },

    async acknowledgeWarning(w) {
      const company = localStorage.getItem('company');
      this.warnings = this.warnings.filter(item => item.tag_mac !== w.tag_mac);
      try {
        await axios.post('/api/notification-history/batch', {
          company,
          items: [{ tag_mac: w.tag_mac, devicename: w.devicename, event_type: 'warning_missing', event_msg: `${w.devicename} - 분실 의심`, original_event_date: w.created_at }],
          acknowledged_by: company || 'unknown'
        });
        await axios.post('/api/updateNotificationStatus', { tag_mac: w.tag_mac, company });
        this.broadcastNotificationChanged();
      } catch (error) {
        console.error('Failed to acknowledge warning:', error);
      }
    },

    async acknowledgeNotification(n, idx) {
      const company = localStorage.getItem('company');
      this.notifications.splice(idx, 1);
      try {
        await Promise.all([
          axios.post('/api/notification-history/batch', {
            company,
            items: [{ tag_mac: n.tag_mac, devicename: n.devicename, event_type: this.statusToEventType(n.status), event_msg: `${n.devicename} - ${this.statusLabel(n.status)}`, original_event_date: n.send_time }],
            acknowledged_by: company || 'unknown'
          }),
          axios.post('/api/deleteNotificationRecent', { tag_mac: n.tag_mac })
        ]);
        this.broadcastNotificationChanged();
      } catch (error) {
        console.error('Failed to acknowledge notification:', error);
      }
    },

    /** acknowledge 완료 직후 다른 화면(상단 종 뱃지/대시보드 ALERTS)을
        즉시 갱신시키는 신호. window 커스텀 이벤트로 broadcast — 듣고 있는
        쪽에서 fetch 을 다시 돌린다. */
    broadcastNotificationChanged() {
      try { window.dispatchEvent(new Event('notification:changed')); } catch (e) { /* SSR 가드 */ }
    },

    toggleAllWarnings(checked) {
      this.selectedWarnings = checked ? this.warnings.map(w => w.tag_mac) : [];
    },

    toggleAllNotifications(checked) {
      this.selectedNotifications = checked ? this.notifications.map(n => n.tag_mac) : [];
    },

    async acknowledgeSelectedWarnings() {
      if (this.selectedWarnings.length === 0) return;
      this.batchProcessing = true;
      const company = localStorage.getItem('company');
      const selected = this.warnings.filter(w => this.selectedWarnings.includes(w.tag_mac));
      try {
        await axios.post('/api/notification-history/batch', {
          company,
          items: selected.map(w => ({
            tag_mac: w.tag_mac,
            devicename: w.devicename,
            event_type: 'warning_missing',
            event_msg: `${w.devicename} - 분실 의심`,
            original_event_date: w.created_at
          })),
          acknowledged_by: company || 'unknown'
        });
        await Promise.all(
          selected.map(w => axios.post('/api/updateNotificationStatus', { tag_mac: w.tag_mac, company }))
        );
        this.warnings = this.warnings.filter(w => !this.selectedWarnings.includes(w.tag_mac));
        this.selectedWarnings = [];
        this.broadcastNotificationChanged();
      } catch (error) {
        console.error('Failed to batch acknowledge warnings:', error);
      } finally {
        this.batchProcessing = false;
      }
    },

    async acknowledgeSelectedNotifications() {
      if (this.selectedNotifications.length === 0) return;
      this.batchProcessing = true;
      const company = localStorage.getItem('company');
      const selected = this.notifications.filter(n => this.selectedNotifications.includes(n.tag_mac));
      try {
        await axios.post('/api/notification-history/batch', {
          company,
          items: selected.map(n => ({
            tag_mac: n.tag_mac,
            devicename: n.devicename,
            event_type: this.statusToEventType(n.status),
            event_msg: `${n.devicename} - ${this.statusLabel(n.status)}`,
            original_event_date: n.send_time
          })),
          acknowledged_by: company || 'unknown'
        });
        await Promise.all(
          selected.map(n => axios.post('/api/deleteNotificationRecent', { tag_mac: n.tag_mac }))
        );
        this.notifications = this.notifications.filter(n => !this.selectedNotifications.includes(n.tag_mac));
        this.selectedNotifications = [];
        this.broadcastNotificationChanged();
      } catch (error) {
        console.error('Failed to batch acknowledge notifications:', error);
      } finally {
        this.batchProcessing = false;
      }
    },

    determineStatus(item) {
      if (item.high_flag === 1) return 'High Temperature';
      if (item.low_flag === 1) return 'Low Temperature';
      if (item.vol_flag === 1) return 'Low Battery';
      if (item.move_flag === 1) return 'Moved';
      if (item.active_flag === 1 && item.active === 0) return 'Wake up';
      if (item.active_flag === 1 && item.active === -1) return 'Sleep';
      return 'Normal';
    },

    statusLabel(status) {
      const map = { 'High Temperature': '고온', 'Low Temperature': '저온', 'Low Battery': '배터리 부족', 'Moved': '이동 감지', 'Wake up': '활성화', 'Sleep': '비활성화', 'Normal': '정상' };
      return map[status] || status;
    },

    statusToEventType(status) {
      const map = { 'High Temperature': 'high_temp', 'Low Temperature': 'low_temp', 'Low Battery': 'low_battery', 'Moved': 'moved', 'Wake up': 'wake_up', 'Sleep': 'sleep' };
      return map[status] || 'unknown';
    },

    statusType(n) {
      const map = { 'High Temperature': 'high', 'Low Temperature': 'low', 'Low Battery': 'battery', 'Moved': 'moved', 'Wake up': 'wakeup', 'Sleep': 'sleep' };
      return map[n.status] || '';
    },

    getTimeAgo(timestamp) {
      if (!timestamp) return '';
      const diffMs = new Date() - new Date(timestamp);
      const diffMin = Math.floor(diffMs / 60000);
      if (diffMin < 60) return `${diffMin}분 전`;
      const diffHours = Math.floor(diffMin / 60);
      if (diffHours < 24) return `${diffHours}시간 전`;
      return `${Math.floor(diffHours / 24)}일 전`;
    },

    // === 히스토리 ===
    async fetchHistory(page) {
      try {
        const company = localStorage.getItem('company');
        const params = { company, page, limit: 50 };
        if (this.historyFilter.event_type) params.event_type = this.historyFilter.event_type;
        if (this.historyFilter.start_date) params.start_date = this.historyFilter.start_date;
        if (this.historyFilter.end_date) params.end_date = this.historyFilter.end_date;
        const response = await axios.get('/api/notification-history', { params });
        this.historyItems = response.data.data || [];
        this.historyPagination = response.data.pagination || { page: 1, totalPages: 1, total: 0 };
      } catch (error) {
        console.error('Failed to fetch history:', error);
      }
    },

    resetHistoryFilter() {
      this.historyFilter = { event_type: '', start_date: '', end_date: '' };
      this.fetchHistory(1);
    },

    toggleAllHistory(checked) {
      this.selectedHistory = checked ? this.historyItems.map(h => h.id) : [];
    },

    async deleteSelectedHistory() {
      if (this.selectedHistory.length === 0) return;
      if (!confirm(`${this.selectedHistory.length}건의 히스토리를 삭제하시겠습니까?`)) return;
      this.batchProcessing = true;
      try {
        const company = localStorage.getItem('company');
        await axios.delete('/api/notification-history/batch', {
          data: { ids: this.selectedHistory, company, deleted_by: company }
        });
        this.selectedHistory = [];
        this.fetchHistory(this.historyPagination.page);
      } catch (error) {
        console.error('Failed to batch delete history:', error);
      } finally {
        this.batchProcessing = false;
      }
    },

    async deleteHistory(id) {
      if (!confirm('이 기록을 삭제하시겠습니까?')) return;
      try {
        const company = localStorage.getItem('company');
        await axios.delete(`/api/notification-history/${id}`, { params: { company } });
        this.fetchHistory(this.historyPagination.page);
      } catch (error) {
        console.error('Failed to delete history:', error);
      }
    },

    eventTypeLabel(type) {
      const map = { 'warning_missing': '분실 의심', 'high_temp': '고온', 'low_temp': '저온', 'low_battery': '배터리 부족', 'moved': '이동 감지', 'wake_up': '활성화', 'sleep': '비활성화', 'HIGH_TEMP': '고온', 'LOW_TEMP': '저온', 'LOW_BATTERY': '배터리 부족', 'BAD_BATTERY': '배터리 불량' };
      return map[type] || type;
    },

    formatDate(dateStr) {
      if (!dateStr) return '-';
      return new Date(dateStr).toLocaleString('ko-KR', { year: '2-digit', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });
    },

    // === 설정 ===
    async fetchSettings() {
      try {
        const company = localStorage.getItem('company');
        const response = await axios.get('/api/companySettings', { params: { company } });
        if (response.data.success && response.data.data && response.data.data.length > 0) {
          this.settings = { ...response.data.data[0] };
          this.settingsLoaded = true;
        }
      } catch (error) {
        console.error('Failed to fetch settings:', error);
      }
    },

    async saveSettings() {
      this.savingSettings = true;
      this.settingsMsg = '';
      try {
        const company = localStorage.getItem('company');
        const response = await axios.put('/api/companySettings', {
          company,
          high_temp_threshold: this.settings.high_temp_threshold,
          low_temp_threshold: this.settings.low_temp_threshold,
          rssi_good_threshold: this.settings.rssi_good_threshold || -65,
          rssi_bad_threshold: this.settings.rssi_bad_threshold || -85,
          battery_good_threshold: this.settings.battery_good_threshold,
          battery_bad_threshold: this.settings.battery_bad_threshold,
          notification_interval: this.settings.notification_interval,
          temp_alert_enabled: this.settings.temp_alert_enabled,
          lost_alert_enabled: this.settings.lost_alert_enabled,
          lost_check_hours: this.settings.lost_check_hours
        });
        if (response.data.success) {
          this.settingsMsg = '저장 완료';
          this.settingsMsgType = 'success';
        }
      } catch (error) {
        this.settingsMsg = '저장 실패';
        this.settingsMsgType = 'error';
      } finally {
        this.savingSettings = false;
        setTimeout(() => { this.settingsMsg = ''; }, 3000);
      }
    }
  },

  created() {
    this.fetchWarnings();
    this.fetchNotifications();
    this.autoRefreshInterval = setInterval(() => {
      if (this.activeTab === 'alerts') {
        this.fetchWarnings();
        this.fetchNotifications();
      }
    }, 15000);
  },

  beforeUnmount() {
    clearInterval(this.autoRefreshInterval);
  }
};
</script>

<style scoped>
.notification-center { width: 100%; max-width: 1200px; margin: auto; padding: 16px; }

/* 탭 */
.tab-header { display: flex; border-bottom: 2px solid #e0e0e0; margin-bottom: 16px; }
.tab-btn { flex: 1; padding: 10px 16px; border: none; background: none; font-size: 15px; font-weight: 500; color: #666; cursor: pointer; border-bottom: 2px solid transparent; margin-bottom: -2px; }
.tab-btn.active { color: #1976d2; border-bottom-color: #1976d2; font-weight: 600; }
.tab-btn:hover:not(.active) { color: #333; background: #f5f5f5; }
.badge { background: #e53935; color: white; font-size: 11px; padding: 2px 7px; border-radius: 10px; margin-left: 6px; font-weight: 600; }

.tab-content { min-height: 150px; }
.section { margin-bottom: 16px; }
.section-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 8px; }
.section-title { font-size: 13px; font-weight: 600; color: #555; margin: 0; }
.btn-batch { background: #1976d2; color: white; border: none; padding: 5px 14px; border-radius: 4px; cursor: pointer; font-size: 13px; font-weight: 600; }
.btn-batch:hover { background: #1565c0; }
.btn-batch:disabled { opacity: 0.6; cursor: not-allowed; }
.btn-batch-danger { background: #e53935; }
.btn-batch-danger:hover { background: #c62828; }
.empty-state { text-align: center; color: #999; padding: 30px 20px; font-size: 14px; }

/* 테이블 공통 */
.alert-table { width: 100%; border-collapse: collapse; font-size: 13px; }
.alert-table th { background: #f5f5f5; padding: 8px 10px; text-align: left; font-weight: 600; color: #555; border-bottom: 2px solid #ddd; white-space: nowrap; }
.alert-table td { padding: 7px 10px; border-bottom: 1px solid #eee; vertical-align: middle; }
.alert-table tbody tr:hover { background: #fafafa; }
.alert-table input[type="checkbox"] { cursor: pointer; width: 16px; height: 16px; }

.td-name { font-weight: 600; color: #333; }
.td-link { cursor: pointer; color: #1976d2; text-decoration: underline; }
.td-link:hover { color: #1565c0; }
.td-value { font-weight: 500; color: #555; white-space: nowrap; }
.td-mac { color: #888; font-family: monospace; font-size: 12px; }
.td-time { color: #999; font-size: 12px; white-space: nowrap; }
.td-msg { color: #555; max-width: 300px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

/* 상태 배지 */
.status-badge { font-size: 11px; padding: 2px 8px; border-radius: 4px; font-weight: 600; white-space: nowrap; }
.badge-warning { background: #fff3e0; color: #e65100; }
.badge-high { background: #ffebee; color: #c62828; }
.badge-low { background: #e3f2fd; color: #1565c0; }
.badge-battery { background: #fff3e0; color: #e65100; }
.badge-moved { background: #e0f2f1; color: #00695c; }
.badge-wakeup { background: #f9fbe7; color: #827717; }
.badge-sleep { background: #f5f5f5; color: #616161; }
.badge-type-warning_missing { background: #fff3e0; color: #e65100; }
.badge-type-high_temp, .badge-type-HIGH_TEMP { background: #ffebee; color: #c62828; }
.badge-type-low_temp, .badge-type-LOW_TEMP { background: #e3f2fd; color: #1565c0; }
.badge-type-low_battery, .badge-type-LOW_BATTERY, .badge-type-BAD_BATTERY { background: #fff3e0; color: #e65100; }
.badge-type-moved { background: #e0f2f1; color: #00695c; }
.badge-type-wake_up { background: #f9fbe7; color: #827717; }
.badge-type-sleep { background: #f5f5f5; color: #616161; }

.row-warning td { background: #fffde7; }

/* 필터 */
.filter-bar { display: flex; gap: 8px; margin-bottom: 12px; align-items: center; flex-wrap: wrap; }
.filter-bar select, .filter-bar input[type="date"] { padding: 6px 10px; border: 1px solid #ddd; border-radius: 4px; font-size: 13px; }
.filter-sep { color: #999; }
.btn-search { background: #1976d2; color: white; border: none; padding: 6px 14px; border-radius: 4px; cursor: pointer; font-size: 13px; font-weight: 600; }
.btn-search:hover { background: #1565c0; }
.btn-reset { background: #f5f5f5; color: #555; border: 1px solid #ddd; padding: 6px 10px; border-radius: 4px; cursor: pointer; font-size: 13px; }
.btn-x { background: none; border: none; color: #bbb; cursor: pointer; font-size: 16px; padding: 0 4px; }
.btn-x:hover { color: #e53935; }

.pagination { display: flex; align-items: center; justify-content: center; gap: 12px; margin-top: 12px; font-size: 13px; }
.pagination button { background: #f5f5f5; border: 1px solid #ddd; padding: 4px 12px; border-radius: 4px; cursor: pointer; }
.pagination button:disabled { opacity: 0.4; cursor: not-allowed; }

/* 설정 - 그리드 */
.settings-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
.settings-card { background: #f9f9f9; border-radius: 8px; padding: 14px; }
.card-title { font-size: 13px; font-weight: 600; color: #555; margin-bottom: 10px; }
.s-row { display: flex; align-items: center; justify-content: space-between; padding: 5px 0; gap: 10px; max-width: 280px; }
.s-row label { font-size: 13px; color: #555; flex: 1; }
.s-row input[type="number"] { width: 90px; padding: 5px 8px; border: 1px solid #ddd; border-radius: 4px; font-size: 13px; text-align: right; }
.settings-actions { grid-column: 1 / -1; display: flex; align-items: center; gap: 12px; }
.btn-save { background: #1976d2; color: white; border: none; padding: 10px 32px; border-radius: 6px; font-size: 14px; font-weight: 600; cursor: pointer; }
.btn-save:hover { background: #1565c0; }
.btn-save:disabled { opacity: 0.6; cursor: not-allowed; }
.settings-msg { font-size: 13px; font-weight: 500; }
.settings-msg.success { color: #2e7d32; }
.settings-msg.error { color: #c62828; }

/* 토글 */
.switch { position: relative; display: inline-block; width: 36px; height: 20px; flex-shrink: 0; }
.switch input { opacity: 0; width: 0; height: 0; }
.slider { position: absolute; cursor: pointer; top: 0; left: 0; right: 0; bottom: 0; background-color: #ccc; border-radius: 20px; transition: .3s; }
.slider:before { position: absolute; content: ""; height: 14px; width: 14px; left: 3px; bottom: 3px; background: white; border-radius: 50%; transition: .3s; }
input:checked + .slider { background-color: #1976d2; }
input:checked + .slider:before { transform: translateX(16px); }
</style>
